import React, { ReactNode } from "react";

import { faAngleRight } from "@fortawesome/pro-solid-svg-icons/faAngleRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";
import { LoadingSpinner } from "@mapmycustomers/ui";

import useMedia, { NOT_DESKTOP_QUERY } from "@app/util/hook/useMedia";

import styles from "./CalendarLayout.module.scss";

interface Props {
  children: ReactNode;
  loading?: boolean;
  sidebar?: ReactNode;
}

const CalendarLayout: React.FC<Props> = ({ children, loading, sidebar }) => {
  const isSmallScreen = useMedia(NOT_DESKTOP_QUERY);
  const [sidebarVisible, , , toggleSidebar] = useBoolean();

  return (
    <div className={styles.container}>
      <div
        className={cn(styles.sidebar, {
          [styles.small]: isSmallScreen,
          [styles.smallVisible]: sidebarVisible,
        })}
      >
        {isSmallScreen && (
          <div className={styles.sidebarOpener} onClick={toggleSidebar}>
            <FontAwesomeIcon icon={faAngleRight} />
          </div>
        )}
        {sidebar}
      </div>
      <div className={cn(styles.content, { [styles.contentWide]: isSmallScreen })}>
        {children}
        {loading && (
          <div className={styles.loader}>
            <LoadingSpinner global />
          </div>
        )}
      </div>
    </div>
  );
};

export default CalendarLayout;
